// Decides where a freshly authenticated user should land, based on their
// Cognito groups. Admins and correctors go straight to their own console so
// the admin pages are actually reachable after admin login; regular users land
// on the customer dashboard. The marketing homepage stays at /home and is
// reachable for everyone, logged in or not.
export function getPostLoginPath(groups: string[] | null | undefined): string {
  const userGroups = groups || [];
  if (userGroups.includes('SuperAdmins')) return '/SuperAdmins/dashboard';
  if (userGroups.includes('Admins')) return '/Admins/dashboard';
  if (userGroups.includes('Correctors')) return '/Correctors/dashboard';
  return '/Users/dashboard';
}
